module.exports = __webpack_public_path__ + "img/aghk-truck-default.1340ae12.svg";